/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_MinInputs */

const en_common_sign_password_min = /** @type {(inputs: Common_Sign_Password_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 8 characters`)
};

const zh_common_sign_password_min = /** @type {(inputs: Common_Sign_Password_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码至少需要 8 个字符`)
};

/**
* | output |
* | --- |
* | "Password must be at least 8 characters" |
*
* @param {Common_Sign_Password_MinInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_password_min = /** @type {((inputs?: Common_Sign_Password_MinInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_MinInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_password_min(inputs)
	return zh_common_sign_password_min(inputs)
});
export { common_sign_password_min as "common.sign.password_min" }